import { Terminal } from "@xterm/xterm";
import { FitAddon } from "xterm-addon-fit";
import { io, Socket } from "socket.io-client";

const serverAddress = "https://socket.elkas.dev";
let mode = "fake";
let socket: Socket | null = null;
const baseTheme = {
  background: "#202B33",
  foreground: "#F5F8FA",
  selection: "#5DA5D533",
  black: "#1E1E1D",
  brightBlack: "#262625",
  red: "#CE5C5C",
  brightRed: "#FF7272",
  green: "#5BCC5B",
  brightGreen: "#72FF72",
  yellow: "#CCCC5B",
  brightYellow: "#FFFF72",
  blue: "#5D5DD3",
  brightBlue: "#7279FF",
  magenta: "#BC5ED1",
  brightMagenta: "#E572FF",
  cyan: "#5DA5D5",
  brightCyan: "#72F0FF",
  white: "#F8F8F8",
  brightWhite: "#FFFFFF",
};

const fitAddon = new FitAddon();
let term = new Terminal({
  fontFamily: '"Cascadia Code", Menlo, monospace',
  theme: baseTheme,
  cursorBlink: true,
  allowProposedApi: true,
});

const terminalContainer = document.getElementById("terminal-container");
if (terminalContainer) {
  term.open(terminalContainer);
} else {
  console.error("Terminal container element not found!");
}

term.loadAddon(fitAddon);
fitAddon.fit();
window.addEventListener("resize", () => fitAddon.fit()); //* Refit on window resize
const prompt = () => {
  term.write("\r\n🗝️  \x1b[92m>\x1b[0m ");
};

let command = ""; //* To store the command being typed

interface Command {
  display: () => void;
  description: string;
}

const runCommand = (input: string) => {
  const command = input.trim().split(" ")[0];
  if (command.length > 0) {
    term.writeln("");
    if (command in commands) {
      (commands[command] as Command).display();
      return;
    }
    // TODO: make this red/error
    term.writeln(`\r\n\r\n${command}: command not found`);
  }
};

const commands: { [key: string]: Command } = {
  start: {
    display: () => {
      term.clear();
      term.writeln(`\r\n`);
      startShell();
    },
    description: `Start the Dungeon Shell demo`,
  },
};

function startFakeTerminal() {
  term.writeln("\r\n\r\nWelcome to \x1b[92mDungeon Shell\x1b[0m!");
  term.writeln(
    "\r\n\r\n\r\nDungeon Shell is an educational game that helps you learn and understand command line tools."
  );
  term.writeln(
    "\r\n\r\nDungeon Shell is currently in a demo state. As such, user sessions will not persist."
  );

  term.writeln(
    "\r\n\r\nHow to play: After starting the game, press \x1b[92mENTER\x1b[0m to advance the story forward."
  );

  // term.writeln(
  //   "\r\n\r\nTo leave feedback, contact Dungeon Shell's developer on X: \x1b[92mhttps://x.com/___rif\x1b[0m"
  // );

  //   term.writeln(
  //     "\r\n\r\n⚠️  The Dungeon is currently undergoing maintenance... ⚠️"
  //   );
  //   term.writeln("\r\nCheck my twitter for updates:");
  //   term.writeln("\r\nhttps://x.com/___rif");
  //   term.writeln(
  //     "\r\nThere will be more information coming soon.\r\n\r\nFor now, all you need to know is that you \x1b[92mpress ENTER\x1b[0m to advance the game forward."
  //   );
  term.writeln(
    "\r\n\r\n\r\n\r\nIf you're ready to enter the Dungeon, type \x1b[92mstart\x1b[0m then press \x1b[92mENTER\x1b[0m."
  );
  prompt();
}

function startShell() {
  mode = "real";
  startLoadingAnimation();
  socket = io(serverAddress, { query: { clientType: "browser" } });
  console.log(`socket:`);
  console.log(socket);
  //* Forward WebSocket output to terminal
  socket.on("output", (data) => {
    term.write(data);
  });
  //* Listen for the "exit" signal from the server
  socket.on("exit", () => {
    console.log(`on socket "exit" handler...`);
    term.writeln("\r\nExited demo, returning to default terminal.");
    console.log(`calling stopShell from on "exit" handler...`);
    stopShell();
  });
  socket.on("stop-animation", () => {
    console.log(`received stop-animation..`);
    stopLoadingAnimation();
  });
  socket.on("cleanup", (isCleaningUp) => {
    console.log(`received cleanup event from server...: ${isCleaningUp}`);
  });
  socket.on("status", (data) => {
    console.log(`received status from server: ${data}`);
  });
  socket.on("disconnect", () => {
    console.log(`in "disconnect" handler and mode is ${mode}...`);
    if (mode === "real") {
      stopShell();
    }
    startFakeTerminal();
  });
}

let loadingInterval: NodeJS.Timeout | null = null;

function startLoadingAnimation() {
  console.log(`in startLoadingAnimation...`);
  const frames = ["-", "\\", "|", "/"];
  let frameIndex = 0;
  //* Start a loop to display the animation
  loadingInterval = setInterval(() => {
    term.write(`\rLoading... ${frames[frameIndex]} `);
    frameIndex = (frameIndex + 1) % frames.length;
  }, 100);
}

function stopLoadingAnimation() {
  if (loadingInterval) {
    clearInterval(loadingInterval);
    loadingInterval = null;
  }
}

function stopShell() {
  console.log(`in stopShell...`);
  socket?.disconnect();
  mode = "fake";
  command = "";
  socket = null;
}

function handleInput(data: string) {
  if (mode === "real" && socket) {
    socket.emit("input", data);
    if (data === "\r") command = ""; //* Reset command on Enter
    else if (data === "\u007F") command = command.slice(0, -1); //* Backspace
    else command += data;
  } else {
    //* Handle "fake" terminal input
    switch (data) {
      case "\u0003": //* Ctrl+C
        term.write("^C");
        command = "";
        prompt();
        break;
      case "\r": //* Enter
        runCommand(command);
        if (command !== "start") {
          prompt();
        }
        command = "";
        break;
      case "\u007F": //* Backspace (DEL)
        if (command.length > 0) {
          term.write("\b \b");
          command = command.slice(0, -1);
        }
        break;
      default:
        if (
          (data >= String.fromCharCode(0x20) &&
            data <= String.fromCharCode(0x7e)) ||
          data >= "\u00a0"
        ) {
          command += data;
          term.write(data);
        }
    }
  }
}

startFakeTerminal();

//* Universal input handler for both real and fake shells
term.onData((data) => handleInput(data));
